import React from "react";

type InfoNoteProps = {
  label?: string;
  children: React.ReactNode;
};

export function InfoNote({ label, children }: InfoNoteProps) {
  const isTip = label === "Meazora Tip";

  return (
    <aside className={`my-8 text-left relative ${isTip ? "card-tip" : "card-info"}`}>
      <div className="pl-5 pr-4 py-2.5 bg-[var(--surface-muted)] border-b border-[var(--border)] rounded-t flex items-center justify-between gap-2">
        <div className="flex items-center gap-2">
          {isTip ? (
            <svg className="w-3.5 h-3.5 text-[var(--tip-color)] shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2.5} aria-hidden="true">
              <path strokeLinecap="round" strokeLinejoin="round" d="M9.663 17h4.673M12 3v1m6.364 1.636l-.707.707M21 12h-1M4 12H3m3.343-5.657l-.707-.707m2.828 9.9a5 5 0 117.072 0l-.548.547A3.374 3.374 0 0014 18.469V19a2 2 0 11-4 0v-.531c0-.895-.356-1.754-.988-2.386l-.548-.547z" />
            </svg>
          ) : (
            <svg className="w-3.5 h-3.5 text-[var(--accent)] shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2.5} aria-hidden="true">
              <path strokeLinecap="round" strokeLinejoin="round" d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
            </svg>
          )}
          <span className="text-[10px] font-mono font-bold tracking-widest text-[var(--ink)] uppercase select-none">
            {label || "Worth Knowing"}
          </span>
        </div>
        <span className="text-[9px] font-mono text-[var(--ink-faint)] tracking-wider select-none uppercase">
          {isTip ? "[ TIP ]" : "[ NOTE ]"}
        </span>
      </div>
      <div className={`${isTip ? "tip-note-content" : "info-note-content"} pl-5 pr-5 py-4 text-sm text-[var(--ink-soft)] leading-relaxed font-sans font-medium`}>
        {children}
      </div>
    </aside>
  );
}
